import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const ok = localStorage.getItem("xseed_age_ok");
    if (!ok) setOpen(true);
  }, []);
  const accept = () => {
    localStorage.setItem("xseed_age_ok", "1");
    setOpen(false);
  };
  const decline = () => { window.location.href = "https://www.google.com"; };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        data-testid="age-gate-modal"
        className="max-w-lg rounded-3xl border-2 border-[#0B0F0C] bg-[#FAF6E8] [&>button]:hidden p-0 overflow-hidden shadow-[10px_10px_0_#15FF73]"
      >
        <div className="bg-[#15FF73] border-b-2 border-[#0B0F0C] px-8 py-5 flex items-center justify-between">
          <div className="font-mono-x text-xs font-bold uppercase tracking-widest">Compliance · 21+</div>
          <span className="bouncy text-3xl">🌿</span>
        </div>
        <div className="p-8">
          <h2 className="font-display text-5xl font-extrabold leading-[0.95] mb-3 tracking-tight">
            You <span className="text-rainbow">21+</span>?
          </h2>
          <p className="text-[#0B0F0C]/70 text-base leading-relaxed mb-7 max-w-md">
            X-Seed only shows products legal where you are. By entering you confirm you're 21+ (or a registered medical patient) and accept our Terms.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button data-testid="age-gate-confirm" onClick={accept} className="btn-x btn-primary flex-1">
              I'm 21+ → Let me in
            </button>
            <button data-testid="age-gate-decline" onClick={decline} className="btn-x btn-ghost">
              Nope
            </button>
          </div>
          <div className="mt-6 pt-5 border-t-2 border-dashed border-[#0B0F0C]/20">
            <p className="text-xs text-[#0B0F0C]/50 leading-relaxed">
              Cannabis products have not been analyzed or approved by the FDA. Keep out of reach of children & pets. Don't drive under the influence.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
